var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcInspectionReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Elements",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Sidebar-icons-V2",
    transform: "translate(-61.000000, -427.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_inspection_report",
    transform: "translate(61.000000, 427.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(2.000000, 3.000000)",
    fill: "#616674"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10,4.44444444 L1.11111111,4.44444444 C0.5,4.44444444 0,4.94444444 0,5.55555556 C0,6.16666667 0.5,6.66666667 1.11111111,6.66666667 L10,6.66666667 C10.6111111,6.66666667 11.1111111,6.16666667 11.1111111,5.55555556 C11.1111111,4.94444444 10.6111111,4.44444444 10,4.44444444 Z M12.2222222,0 L1.11111111,0 C0.5,0 0,0.5 0,1.11111111 C0,1.72222222 0.5,2.22222222 1.11111111,2.22222222 L12.2222222,2.22222222 C12.8333333,2.22222222 13.3333333,1.72222222 13.3333333,1.11111111 C13.3333333,0.5 12.8333333,0 12.2222222,0 Z M1.11111111,11.1111111 L6.66666667,11.1111111 C7.27777778,11.1111111 7.77777778,10.6111111 7.77777778,10 C7.77777778,9.38888889 7.27777778,8.88888889 6.66666667,8.88888889 L1.11111111,8.88888889 C0.5,8.88888889 0,9.38888889 0,10 C0,10.6111111 0.5,11.1111111 1.11111111,11.1111111 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1516245,13.3496212 C17.6738467,12.4607323 17.9294023,11.3829545 17.6849579,10.2162878 C17.3071801,8.3940656 15.7738467,6.93851004 13.9294023,6.70517671 C11.0071801,6.32739893 8.54051341,8.78295449 8.9294023,11.7051767 C9.17384675,13.5496212 10.6182912,15.0829545 12.4405134,15.4607323 C13.6071801,15.7051767 14.6849579,15.4496212 15.5738467,14.9273989 L17.6405134,16.9940656 C18.0738467,17.4273989 18.7738467,17.4273989 19.2071801,16.9940656 L19.2071801,16.9940656 C19.6405134,16.5607323 19.6405134,15.8607323 19.2071801,15.4273989 L17.1516245,13.3496212 Z M13.3405134,13.3273989 C12.1182912,13.3273989 11.1182912,12.3273989 11.1182912,11.1051767 C11.1182912,9.88295449 12.1182912,8.88295449 13.3405134,8.88295449 C14.5627356,8.88295449 15.5627356,9.88295449 15.5627356,11.1051767 C15.5627356,12.3273989 14.5627356,13.3273989 13.3405134,13.3273989 Z",
    id: "Shape"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcInspectionReport);
export default __webpack_public_path__ + "static/media/ic_inspection_report.a8aa376b1114e25a7dc054e7c5e4c772.svg";
export { ForwardRef as ReactComponent };